<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="egyuttlakasVisible()" :attributes="egyuttlakas"/>

            <!-- <BnFormField v-if="myhomeVisible()" :attributes="myhome"/> -->

            <BnFormField v-if="egyuttcascoVisible()" :attributes="egyuttcasco"/>

            <BnFormField v-if="egyutteletVisible()" :attributes="egyuttelet"/>

            <BnFormField v-if="egfbVisible()" :attributes="egfb"/>

            <BnFormField :attributes="muszaki_vizsga_180_napon_belul"/>

            <BnFormField v-if="kmallaIsmertVisible()" :attributes="kmallas"/>

            <BnFormField v-if="tudatosVisible()" :attributes="tudatos"/>

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import {LASSU, MIKROMOBILITAS, POTKOCSI, ROLLER} from '../../../../../../../modules/Gepjarmu';
import { UJ } from '../../../../../../../modules/Const';
import TariffAnnouncementUtils from '../../../../../../../utils/TariffAnnouncementUtils';

export default {
    name: 'KedvezmenyekB1',
    components: {
        KedvezmenyekBase,
        BnFormField,
    },
    mixins: [Kedvezmeny],
    methods: {
        kmallaIsmertVisible() {
            return ![POTKOCSI, LASSU, MIKROMOBILITAS, ROLLER].includes(this.$store.getters.gepjarmu.fajta);
        },
        egyuttlakasVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        myhomeVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        egyuttcascoVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        egyutteletVisible() {
            return ((this.isSZGK() || this.isTeherKisebb3500kg())
                && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(
                    2025,
                    'kgfb',
                    this.$store
            ));
        },
        egfbVisible() {
            return this.getValue('tarifaData.eugyintezes') === true && ![MIKROMOBILITAS, ROLLER].includes(this.$store.getters.gepjarmu.fajta);
        },
        muszakiVizsgaEditable() {
            return !this.disabled && this.$store.getters.tarifaData.ajanl_megkotok_type !== UJ && ![MIKROMOBILITAS, ROLLER].includes(this.$store.getters.gepjarmu.fajta);
        },
        tudatosVisible() {
            return TariffAnnouncementUtils.isKockakezdetLesser(
                2025,
                'kgfb',
                this.$store,
            ) && ![MIKROMOBILITAS, ROLLER].includes(this.$store.getters.gepjarmu.fajta);
        },
    },
    data() {
        return {
            myhome: {
                type: 'checkbox',
                label: 'Otthonom lakás együttkötés kedvezmény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.1.myhome',
                mezo: 'myhome',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            },
            kmallas: {
                type: 'checkbox',
                label: 'Km óra állása ismert',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.1.kmallas',
                mezo: 'alliazn_kmallas',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            },
            egfb: {
                type: 'checkbox',
                label: 'e-GFB kedvezmény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.1.egfb',
                mezo: 'egfb',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            },
            allianz_elozmeny_potdij: {
                type: 'select',
                label: 'Előzmény szerződés megszűnésének oka',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekalaptabla.1.allianz_elozmeny_potdij',
                mezo: 'allianz_elozmeny_potdij',
                help: true,
                rules: [],
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 'EGYIKSEM', value: 'Egyik sem' },
                    { key: 'DNF', value: 'Díjnemfizetéssel szűnt meg' },
                    { key: 'KOZOS', value: 'Közös megegyezéssel szűnt meg' },
                    { key: 'BIZTOSITOIFELMONDAS', value: 'Biztosítói felmondás' },
                ],
                change: this.shouldRecalc,
            },
            szezonalis_gumiabrons: {
                type: 'checkbox',
                label: 'Évszaknak megfelelő gumiabroncs',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekalaptabla.1.szezonalis_gumiabroncs',
                rules: [],
                help: true,
                mezo: 'szezonalis_gumiabroncs',
                change: this.shouldRecalc,
            },
            muszaki_vizsga_180_napon_belul: {
                type: 'checkbox',
                label: 'Utolsó műszaki vizsga időpontja 180 napon belüli?',
                visible: true,
                editable: this.muszakiVizsgaEditable(),
                path: 'kedvezmenyekalaptabla.1.muszaki_vizsga_180_napon_belul',
                rules: [],
                help: true,
                mezo: 'muszaki_vizsga_180_napon_belul',
                change: this.shouldRecalc,
            },
            tudatos: {
                type: 'checkbox',
                label: 'Tudatos vezetők kedvezménye',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.1.tudatos',
                mezo: 'alliazn_tudatos',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            },
        };
    },
    computed: {
        egyuttlakas() {
            return {
                type: 'checkbox',
                label: 'Lakás együttkötés kedvezmény',
                visible: true,
                editable: !this.isEgyuttlakasDisabled && !this.egyuttkotve,
                path: 'kedvezmenyekbiztosito.1.egyuttlakas',
                mezo: 'egyuttlakas',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            };
        },
        egyuttcasco() {
            return {
                type: 'checkbox',
                label: 'CASCO együttkötés kedvezmény',
                visible: true,
                editable: !this.isEgyuttcascoDisabled && !this.egyuttkotve,
                path: 'kedvezmenyekbiztosito.1.egyuttcasco',
                mezo: 'egyuttcasco',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            };
        },
        egyuttelet() {
            return {
                type: 'checkbox',
                label: 'Élet, egészség együttkötés kedvezmény',
                visible: true,
                editable: !this.isEgyutteletDisabled,
                path: 'kedvezmenyekbiztosito.1.egyuttelet',
                mezo: 'egyuttelet',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            };
        },
        isEgyuttlakasDisabled() {
            return this.disabled || this.isEgyuttcascoSelected || this.isEgyutteletSelected;
        },
        isEgyuttcascoDisabled() {
            return this.disabled || this.isEgyuttlakasSelected || this.isEgyutteletSelected;
        },
        isEgyutteletDisabled() {
            return this.disabled || this.isEgyuttlakasSelected || this.isEgyuttcascoSelected;
        },
        isEgyuttlakasSelected() {
            return this.getValue('kedvezmenyekbiztosito.1.egyuttlakas') === true;
        },
        isEgyuttcascoSelected() {
            return this.getValue('kedvezmenyekbiztosito.1.egyuttcasco') === true;
        },
        isEgyutteletSelected() {
            return this.getValue('kedvezmenyekbiztosito.1.egyuttelet') === true;
        },
    },
};
</script>
